export const LOCALE_PT_BR = 'PT_BR';
export const LOCALE_PT_JP = 'PT_JP';
export const LOCALE_PT_US = 'PT_US';
export const LOCALE_PT_UK = 'PT_UK';
export const LOCALE_PT_IE = 'PT_IE';
export const LOCALE_PT_PT = 'PT_PT';
export const LOCALE_PT_AO = 'PT_AO';
export const LOCALE_PT_BO = 'PT_BO';
export const LOCALE_PT_IT = 'PT_IT';
export const LOCALES = [
  { name: 'Brasil', code: LOCALE_PT_BR },
  { name: 'Brasil / Japão', code: LOCALE_PT_JP },
  { name: 'Brasil / USA', code: LOCALE_PT_US },
  { name: 'Brasil / Reino Unido (UK)', code: LOCALE_PT_UK },
  { name: 'Brasil / Irlanda', code: LOCALE_PT_IE },
  { name: 'Portugal', code: LOCALE_PT_PT },
  { name: 'Angola', code: LOCALE_PT_AO },
  { name: 'Brasil / Bolívia', code: LOCALE_PT_BO },
  { name: 'Brasil / Italia', code: LOCALE_PT_IT },
];

const LOCALE_CODE_TO_OBJECT = LOCALES.reduce((acc, currentObj) => {
  acc[currentObj.code] = currentObj;
  return acc;
}, {});

export { LOCALE_CODE_TO_OBJECT };
